import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const Home = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useEffect(() => {
    window.scrollTo(0, 0);

    // Set document title
    document.title = 'GrowthLink Digital Marketing Agency India | SEO Social Media Content Strategy';

    // Set meta tags
    const metaTags = [
      { name: 'description', content: 'GrowthLink is a leading digital marketing agency in India specializing in SEO optimization, social media marketing, content strategy, PPC advertising, email marketing, and brand development. Transform your business with data-driven digital marketing solutions and accelerate your growth today.' },
      { name: 'keywords', content: 'digital marketing agency, SEO optimization, social media marketing, content strategy, PPC advertising' },
      { property: 'og:title', content: 'GrowthLink Digital Marketing Agency India | SEO Social Media Content Strategy' },
      { property: 'og:description', content: 'GrowthLink is a leading digital marketing agency in India specializing in SEO optimization, social media marketing, content strategy, PPC advertising, email marketing, and brand development.' },
      { property: 'og:url', content: siteUrl },
      { property: 'og:image', content: `${siteUrl}/vite.svg` },
      { name: 'twitter:title', content: 'GrowthLink Digital Marketing Agency India | SEO Social Media Content Strategy' },
      { name: 'twitter:description', content: 'GrowthLink is a leading digital marketing agency in India specializing in SEO optimization, social media marketing, content strategy, PPC advertising, email marketing, and brand development.' },
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attribute = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attribute}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, value!);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    // Set canonical link
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = siteUrl;

    // Set JSON-LD schema
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "GrowthLink",
      "url": siteUrl,
      "logo": `${siteUrl}/vite.svg`,
      "description": "GrowthLink is a leading digital marketing agency in India specializing in SEO optimization, social media marketing, content strategy, and comprehensive digital solutions to accelerate your business growth.",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "IN",
        "addressRegion": "Telangana",
        "addressLocality": "India"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-8931893177",
        "contactType": "customer service",
        "email": "growthlink2705@gmail.com",
        "availableLanguage": "English"
      },
      "sameAs": [
        "https://linkedin.com",
        "https://twitter.com",
        "https://instagram.com",
        "https://facebook.com"
      ]
    };

    let script = document.querySelector('script[type="application/ld+json"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemaData);
  }, [siteUrl]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesGrid />
        <AboutSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
